var TECL_Reviews = {
  ReviewsAtATime: 5,
  CurrentProductId: "",
  CurrentReviewCount: 0,
  CurrentOrderBy: "",
  Initialise: function () {
    $( document ).ready( function () {
      TECL_Reviews.CurrentProductId = $( "#reviewsProductId" ).val();
      TECL_Reviews.CurrentOrderBy = $("#reviewsSort").val();
      TECL_Reviews.CurrentReviewCount = $( ".review" ).length;

      $( "#reviewRating" ).barrating( {
        theme: "fontawesome-stars",
      } );

      $( document ).on( "change", "#reviewsSort", function ( e ) {
        var orderBy = $( "#reviewsSort" ).val();
        TECL_Reviews.SortReviews( orderBy );
      } );

      $( document ).on( "click", ".load-more-reviews a", function ( e ) {
        TECL_Reviews.LoadMoreReviews();
      } );

      $( document ).on( "click", ".add-review", function( e ) {
        TECL_Reviews.OpenAddReviewModal( e );
      } );

      $( document ).on( "click", ".submit-add-review", function( e ) {
        TECL_Reviews.AddReview( e );
      } );

      $( document ).on( "click", ".review-summary-anchor", function( e ) {
        $("body, html").animate({
            scrollTop: $( "#reviews" ).offset().top - 50
        }, 500 );
      } );
    } );
  },
  OpenAddReviewModal: function( e ) {
    $( "#addReviewModal" ).modal( "show" );
  },
  ShowLoadMoreReviews: function () {
    $( ".load-more-reviews" ).show();
  },
  HideLoadMoreReviews: function () {
    $( ".load-more-reviews" ).hide();
  },
  SortReviews: function ( orderBy ) {
    TECL_Reviews.GetReviews( TECL_Reviews.CurrentReviewCount, 0, orderBy, false );
    TECL_Reviews.CurrentOrderBy = orderBy;
  },
  LoadMoreReviews: function () {
    TECL_Reviews.GetReviews(
      TECL_Reviews.ReviewsAtATime,
      TECL_Reviews.CurrentReviewCount,
      TECL_Reviews.CurrentOrderBy,
      true
    );
    
    TECL_Reviews.CurrentReviewCount += TECL_Reviews.ReviewsAtATime;
  },
  GetReviews: function ( limit, skip, orderBy, append ) {
    $.ajax( {
      url: "/umbraco/Surface/ReviewSurface/GetProductReviews",
      type: "POST",
      data: {
        nodeId: TECL_Reviews.CurrentProductId,
        limit: limit,
        skip: skip,
        orderBy: orderBy
      },
      success: function ( data ) {
        if( !append ) {
          $( ".review-items" ).html( data.Reviews );
        } else {
          $( ".review-items" ).append( data.Reviews );
        }

        if ( data.Remaining > 0 ) {
          TECL_Reviews.ShowLoadMoreReviews();
        } else {
          TECL_Reviews.HideLoadMoreReviews();
        }
      }
    } );
  },
  ValidateField: function ( fieldSelector ) {
    var isValid = false;
    var fieldValue = $( fieldSelector ).val() || "";

    if ( fieldValue.length > 0 ) {
      isValid = true;
      $( fieldSelector ).next( ".field-validation-error" ).remove();
    } else {
      isValid = false;
      $( fieldSelector ).after( '<p class="field-validation-error">This field is required.</p>' );
    }

    return isValid;
  },
  AddReview: function () {
    var isValid = false;

    if ( TECL_Reviews.ValidateField( "#reviewerName" ) ) {
      isValid = true;
    } else {
      isValid = false;
    }

    if ( TECL_Reviews.ValidateField( "#reviewRating" ) ) {
      isValid = true;
    } else {
      isValid = false;
    }

    if ( TECL_Reviews.ValidateField( "#reviewContent" ) ) {
      isValid = true;
    } else {
      isValid = false;
    }

    if ( isValid ) {
      var reviewerName = $( "#reviewerName" ).val();
      var reviewRating = $( "#reviewRating" ).val();
      var reviewContent = $( "#reviewContent" ).val();

      $.ajax( {
        url: "/umbraco/Surface/ReviewSurface/SubmitReview",
        type: "POST",
        data: {
          reviewerName: reviewerName,
          content: reviewContent,
          rating: reviewRating,
          reviewedContent: TECL_Reviews.CurrentProductId
        },
        success: function ( data ) {
          if ( data.Error ) {
            console.log( data.Error );
          } else {
            $( "#addReviewModal" ).find( ".form-control" ).val( "" );
            $( "#addReviewModal" ).modal( "hide" );
            $( "#reviewSuccessModal" ).modal( "show" );
          }
        }
      } );
    }
  }
}